import React, { useState, HtmlHTMLAttributes } from 'react';
import classNames from 'classnames';
import * as native from '@/utils/native';
import { TrackData } from '../../../index';
import Modal from '../modal';
import { openBrowser } from '@/utils/native';
import { getDisplayPrice, getIncomeSource } from '@/utils/vip';
import AppleIcon from '@/assets/image/vip/apple-icon.png';
import InfoIcon from '@/assets/image/vip/info-icon.png';

import styles from './index.module.css';
import { useAtom } from 'jotai';
import {
  curProductAtom,
  hasFetchUserInfoAtom,
  resultModalTitleAtom,
  userInfoAtom,
  vipInfoAtom,
  visibleResultAtom,
} from '@/store';
import { track } from '@/utils/common';
import { getUserInfo } from '@/utils/user';

interface IProps extends HtmlHTMLAttributes<HTMLDivElement> {
  handleLogin?: () => void;
  onSuccess?: () => void;
  onFail?: () => void;
}

const ProductPayAppStore: React.FC<IProps> = (props: IProps) => {
  const { children, handleLogin, onSuccess, onFail } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [visible, setVisible] = useState<boolean>(false);

  const [hasFetchUserInfo] = useAtom(hasFetchUserInfoAtom);
  const [userInfo] = useAtom(userInfoAtom);
  const [curProduct] = useAtom(curProductAtom);
  const [, setResultModalTitle] = useAtom(resultModalTitleAtom);
  const [, setVisibleResult] = useAtom(visibleResultAtom);

  const noLogin = hasFetchUserInfo && !userInfo?.id;

  const handleIAPsuccess = async () => {
    await getUserInfo();
    setResultModalTitle('感谢您的订阅！');
    setVisibleResult(true);
  };

  const handleClickBtn = () => {
    if (noLogin) {
      handleLogin && handleLogin();
      return;
    }

    if (loading || !curProduct) return;

    // 唤起Mac支付
    setLoading(true);

    const promotion = curProduct.promotions[0] || {};
    const parmas = {
      amount: getDisplayPrice(curProduct).price * 100,
      product_id: curProduct.productId,
      third_product_id: curProduct.thirdProductId,
      offer_identifier: promotion.thirdPromotionCode,
      platform: curProduct.platform,
      type: curProduct.productType,
      access_token: localStorage.getItem('access_token'),
    };

    setTimeout(() => {
      native.buyProduct(parmas, (value: any) => {
        if (value) {
          const info = JSON.parse(value);
          const data = typeof info === 'string' ? JSON.parse(info) : info;
          if (data.code === 0) {
            handleIAPsuccess && handleIAPsuccess();

            track({
              event_id: 'vip_paidprocess_success',
              event_name: '支付成功',
              params: {
                amount: (parmas.amount / 100).toString(),
                category: '苹果支付',
                product_id: curProduct.productId || '',
                product_id_apple: curProduct.thirdProductId,
              },
            });
          } else {
            // if (+data.code === 10003) {
            //   message.error('您已取消购买，如需购买请重新支付');
            // } else if (+data.code === 10011) {
            //   message.error('网络错误，请检查网络连接');
            // }

            onFail && onFail();

            track({
              event_id: 'vip_paidprocess_fail',
              event_name: '支付失败',
              params: {
                amount: (parmas.amount / 100).toString(),
                category: '苹果支付',
                product_id: curProduct.productId,
                product_id_apple: curProduct.thirdProductId,
                fail_reason: value,
              },
            });

            setVisible(true);
          }

          setLoading(false);
        }
      });
    }, 100);
  };

  const handleJumpTerm = () => {
    let params = {
      category: '会员条款',
      product_id: curProduct?.productId,
    };

    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params,
    });

    let prefix = process.env.REACT_APP_ENV;

    if (process.env.REACT_APP_ENV === 'release') {
      prefix = '';
    }

    const url = `https://${prefix}pc.meitu.com/agreement`;

    openBrowser(url);
  };

  // 页面第一次加载商品时候才需要展示骨架屏
  const showSkeleton = !curProduct;

  return (
    <>
      <div className={styles.module}>
        <div
          className={classNames(styles.btn, showSkeleton && styles.skeleton)}
          onClick={handleClickBtn}
        >
          {loading ? (
            <span className={styles.loading}></span>
          ) : (
            <>
              {/* <img className={styles.icon} src={AppleIcon} alt="" /> */}
              <span>{noLogin ? '点击登录' : (curProduct as any)?.buttonTitle}</span>
            </>
          )}
        </div>
        <div className={classNames(styles.term, showSkeleton && styles.skeleton)}>
          开通前请阅读 <a onClick={handleJumpTerm}>《会员服务》</a>协议
        </div>
        {children}
      </div>
      <Modal
        wrapStyle={{ borderRadius: getIncomeSource() !== 'MTXX-WEB' ? 0 : '0 12px 12px 0' }}
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <div className={styles.body}>
          <img className={styles.modalIcon} src={InfoIcon} alt="" />
          <div className={styles.title}>支付失败</div>
          <div
            className={styles.modalBtn}
            onClick={() => {
              setVisible(false);
              setTimeout(() => {
                handleClickBtn();
              }, 500);
            }}
          >
            重新支付
          </div>
        </div>
      </Modal>
    </>
  );
};

export default React.memo(ProductPayAppStore);
